import { render, staticRenderFns } from "./UcRegisterEntryPartnerSelector.yaml?vue&type=template&id=be9358a6&component"
import script from "./UcRegisterEntryPartnerSelector.yaml?vue&type=script&lang=ts&component"
export * from "./UcRegisterEntryPartnerSelector.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports